import { Elements } from "@stripe/react-stripe-js";
import {
  StripeElementsOptionsClientSecret,
  loadStripe
} from "@stripe/stripe-js";
import { useEffect } from "react";
import {
  Outlet,
  useNavigate,
  useParams,
  useRouteLoaderData
} from "react-router";

import logo from "../../assets/liftlock-logo.svg";
import { AppLoaderData } from "../../types";
import styles from "./LiftLock.module.css";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY as string);

export const LiftLock = () => {
  const navigate = useNavigate();
  const { proposal } = useParams();
  const {
    quote: { roofResealingStripeIntentClientSecret }
  } = useRouteLoaderData<AppLoaderData>("root")!;

  useEffect(() => {
    if (!roofResealingStripeIntentClientSecret) {
      void navigate(`/${proposal}`);
    }
  }, [roofResealingStripeIntentClientSecret, navigate, proposal]);

  // The useEffect will handle a redirect in this case
  // This helps to not pass bad data in the meantime
  if (!roofResealingStripeIntentClientSecret) {
    return;
  }

  const appearance: StripeElementsOptionsClientSecret["appearance"] = {
    theme: "stripe",
    variables: {
      fontFamily: "Roboto",
      gridColumnSpacing: "24px",
      gridRowSpacing: "24px"
    },
    rules: {
      ".Label": {
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.5px"
      }
    }
  };
  const options = {
    clientSecret: roofResealingStripeIntentClientSecret,
    appearance
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.container}>
          <img src={logo} className={styles.logo} alt="LiftLock logo" />
        </div>
      </div>
      {roofResealingStripeIntentClientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <Outlet />
        </Elements>
      )}
    </div>
  );
};
